import { useGradingCenterSubmissions } from "../../../../contexts/GradingCenterContext";
import AdminTablePagination from "../../AdminTable/AdminTablePagination";

const GradingCenterTableFooter = () => {
  const { totalSubmissionsCount, page, totalPages, pageSize, setPage, setPageSize } = useGradingCenterSubmissions();
  return (
    <>
      {totalSubmissionsCount > 0 && (
        <AdminTablePagination
          currentPage={page}
          totalPages={totalPages}
          totalItems={totalSubmissionsCount}
          itemsPerPage={pageSize}
          onPageChange={setPage}
          onItemsPerPageChange={(newPageSize) => {
            setPageSize(newPageSize);
            setPage(1);
          }}
        />
      )}
    </>
  );
};

export default GradingCenterTableFooter;
